<template>
  <div class="common">
      <a-row :gutter="24">
          <a-col :span="12" v-for="item in tableData" :key="item.tenantName">
            <div class="bank-card">
                <div class="head spaceBetween">
                    <div class="spaceLeft" style="flex:1;margin-right:10px;"><span :class="item.bank" class="logo"></span><div class="ellipsis" style="flex:1;">{{item.tenantNameShort || item.tenantName}}</div></div>
                    <div class="normal-text">
                        起止时间：{{item.stDt | dateFormat("YYYY-mm-dd")}} ~ {{item.edDt | dateFormat("YYYY-mm-dd")}}
                    </div>
                </div>
                <div class="body spaceBetween">
                    <div style="flex:1;margin-right:24px;">
                        <div class="title-text">额度总额(元)</div>
                        <div class="blue-text">{{item.lmtAmt | splitK}}</div>
                        <div class="block-text">
                            <div class="spaceBetween" style="margin-bottom:16px">
                                <span class="spaceLeft"><span class="spont"></span>已用额度：</span>
                                <span>{{item.usableAmt | splitK}} 元</span>
                            </div>
                            <div class="spaceBetween">
                                <span class="spaceLeft"><span class="spont"></span>剩余可用额度：</span>
                                <span>{{item.usedAmt | splitK}} 元</span>
                            </div>
                        </div>
                    </div>
                    <div>
                      <comprehensiveChart :id="item.lmtId" :usableAmt.sync="item.usableAmt" :usedAmt.sync="item.usedAmt" :lmtAmt.sync="item.lmtAmt"/>
                    </div>
                </div>
            </div>
          </a-col>
      </a-row>
    <div v-if="tableData.length==0" style="text-align: center;line-height: 46px;background:#fff;">暂无额度</div>
  </div>
</template>

<script>
import { pagingQuotaList } from "@/api/comprehensive.js"
import comprehensiveChart from "./comprehensive-chart"
export default {
    props:{
        tabType:{
            type: [String],
            required: false,
            default: function () {
                return ""; //所属tab的分类
            }
        },
        status:{
            type: [String],
            required: false,
            default: function () {
                return "";
            }
        },
    },
    name: "funding-main",
    components:{
      comprehensiveChart
    },
    data() {
        return {
            searchData:{
                ctlgId:""
            },
            formConfig:[
                {
                    prop: "ctlgId",
                    type: "tags",
                    label: "类型",
                    hide:this.tabType=="receiptCol",
                    option:[
                        { value: 'all', name: '全部' },
                        { value: 'BF', name: '转账' },
                        { value: 'BH', name: '解冻支付' },
                        { value: 'BS', name: '支付冻结' },
                        { value: 'TX', name: '提现' }
                    ]
                }
            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "",
                sortOrder: "",
                total: 0,
                showSizeChanger:true,
                showQuickJumper:true,
                pageSizeOptions:['5','10', '20', '50','100'],
                showTotal:(total)=>{
                return `共 ${total} 条`
                }
            },
            loading: false,

        };
    },
    computed: {
    },
    methods: {
        search(data) {
            this.searchData = data || this.searchData;
            this.getTableData();
        },
        getTableData(){
            this.loading = true;
            const params = {
                ctlgId: this.searchData.ctlgId=="all"?"":this.searchData.ctlgId,
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize
            };
            pagingQuotaList(params,true)
            .then((res)=>{
                this.loading = false;
                this.pagination.total = res.data.grid.total||0;
                this.tableData = res.data.grid.list;
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
        },
        refresh(){
            this.getTableData();
        }
    },
    created() {
        this.getTableData();
    },
    mounted() {
    },
    activated() {},
};
</script>
<style scoped lang="less">
    .input-content>div{
        margin:10px 20px 20px 0;
    }
    .common /deep/ .search-item-lable {
        min-width: 85px;
    }
    .common /deep/ .search-item-lable-left{
        min-width: auto!important;
    }
    .bank-card{
        margin-top:10px;
        margin-right: 16px;
        background: #fff;
        padding:8px 16px;
        box-shadow: 0 0 6px 3px rgba(134, 147, 154, 0.1);
        border-radius: 3px;
        .head{
            line-height: 48px;
            height: 48px;
            border-bottom: 1px solid #EEF5FB;
            font-size: 18px;
            color: #333333;
            font-weight: bold;
        }
        .body{
            padding:16px 0;
            .text{
                color:#737F8E;
                margin-bottom: 8px;
            }
            button{
                width: 150px;
                margin-bottom: 10px;
            }
        }
        .normal-text{
            color: #999;
            font-size: 14px;
            font-weight: normal;
        }
        .title-text{
            font-size: 18px;
            font-weight: bold;
            color:#333;
        }
        .blue-text{
            color: #1990FF;
            font-size: 32px;
        }
        .block-text{
            background: #F9F9FA;
            padding:24px 24px;
            border-radius: 3px;
            color:#666;
            .spont{
                display: inline-block;
                border-radius: 100%;
                margin-right: 5px;
                width: 4px;
                height: 4px;
                background: #1990FF;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/inquiry/comprehensive-main.vue